import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'

const WeeklyEvent = ({ event }) => {
  const { t } = useTranslation()
  return (
    <div className={styles.commonWrapper}>
      {event.index === 0 && event.eventsAtSameTime > 1 ? (
        <div
          className={`${styles.title} ${event.relation_user_mixr === 'attending' && styles.attending} ${
            styles.showMore
          }`}>
          {event.title}
        </div>
      ) : (
        <div className={`${styles.title} ${event.relation_user_mixr === 'attending' && styles.attending}`}>
          {event.title}
        </div>
      )}
    </div>
  )
}
export default WeeklyEvent
